import { FetchPackList, countOfPackages } from '../../pages/supOrgPackList/orgPackListFun/fetchPackList';
import { getOrganizers } from '../getOrganizers';

const commonBaseAPIServiceConfig = {
    fetchOrg: ({ serviceType, setOrgData, setLoading }) => {
        return getOrganizers(serviceType, setOrgData, setLoading);
    },
    fetchPackList: async ({
        setTripData,
        selectedOrg,
        selectedStatus,
        limit,
        offSet,
        datesType,
        group,
        setLoading,
        serviceType,
        searchRe
    }) => {
        return await FetchPackList(
            setTripData,
            selectedOrg,
            selectedStatus,
            limit,
            offSet,
            datesType,
            group,
            setLoading,
            serviceType,
            searchRe
        );
    },
    countOfPackages: ({
        setTotalCount,
        selectedOrg,
        selectedStatus,
        datesType,
        group,
        setLoading,
        serviceType,
        searchRe
    }) => {
        return countOfPackages(
            setTotalCount,
            selectedOrg,
            selectedStatus,
            datesType,
            group,
            setLoading,
            serviceType,
            searchRe
        );
    }
};

export const supportPackListServiceConfig = {
    trip: {
        fetchOrg: async ({ serviceType, setOrgData, setLoading }) => {
            return getOrganizers(serviceType, setOrgData, setLoading);
        },
        fetchPackList: async ({
            setTripData,
            selectedOrg,
            selectedStatus,
            limit,
            offSet,
            datesType,
            group,
            setLoading,
            serviceType,
            searchRe
        }) => {
            return await FetchPackList(
                setTripData,
                selectedOrg,
                selectedStatus,
                limit,
                offSet,
                datesType,
                group,
                setLoading,
                serviceType,
                searchRe
            );
        },
        countOfPackages: ({
            setTotalCount,
            selectedOrg,
            selectedStatus,
            datesType,
            group,
            setLoading,
            serviceType,
            searchRe
        }) => {
            return countOfPackages(
                setTotalCount,
                selectedOrg,
                selectedStatus,
                datesType,
                group,
                setLoading,
                serviceType,
                searchRe
            );
        }
    },
    gu: commonBaseAPIServiceConfig,
    act: commonBaseAPIServiceConfig,
    camp: commonBaseAPIServiceConfig
};
